export default [
  [`Размеры`, `3XL`, `4XL`, `5XL`, `6XL`],
  [`Российский размер`, `56`, `58`, `60`, `62`],
  [`Плечи`, `48`, `49`, `50`, `51`],
  [`Грудь`, `60`, `62`, `64`, `66`],
  [`Длина`, `74`, `76`, `76`, `78`]
];
